import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=8692218e&scoped=true"
import script from "./PlayBox.vue?vue&type=script&lang=js"
export * from "./PlayBox.vue?vue&type=script&lang=js"
import style0 from "./PlayBox.vue?vue&type=style&index=0&id=8692218e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8692218e",
  null
  
)

export default component.exports